'use client'
import {configureStore, ThunkAction, Action} from "@reduxjs/toolkit";
// import gameModeReducer from "./(pages)/components/gameModeSlice";
import unityBarReducer from "@/app/(game)/unity-game/unityBarSlice";
import mainReducer from "@/app/MainSlice";
import shopItemsReducer from "./(pages)/shopItemsSlice";
import accountInfoReducer from "./(pages)/account/accountSlice";
// import UserGlobalMgr from "@/Core/UserGlobalMgr";
// import webSyncDataReducer from "@/Core/WebDataMgr/WebSyncDataSlice";
import userReducer from "@/app/userSlice";

export const store = configureStore({
    reducer: {
        // userGlobal:UserGlobalMgr,
        // userSyncData: webSyncDataReducer,//用户数据。走同步接口
        userInfo: userReducer,
        unityBar: unityBarReducer,
        mainState: mainReducer,
        shopItems: shopItemsReducer,
        accountInfo: accountInfoReducer,
    }
})

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>



export default store;


